import { RouteComponentProps } from 'react-router-dom';
import { useFeatureFlag } from 'hooks/use-account-redesign';
import { AddTask } from './add-task';

export function AddTaskResident({
  history,
}: {
  history: RouteComponentProps['history'];
}) {
  const { isEnabled: isMaintenanceAgentEnabled } =
    useFeatureFlag('maintenance-agent');

  return (
    <AddTask
      history={history}
      isHomeowner={false}
      isMaintenanceAgentEnabled={isMaintenanceAgentEnabled}
    />
  );
}
